export default __webpack_public_path__ + "static/media/soft-alliance.ced9e7ee.png";